// Geometry helpers shared by the map surfaces.

export interface LatLng {
  lat: number
  lng: number
}

/** Compass bearing from one point to another, 0–360 (0 = north, 90 = east). */
export function bearingDegrees(from: LatLng, to: LatLng): number {
  const rad = (deg: number) => (deg * Math.PI) / 180
  const lat1 = rad(from.lat)
  const lat2 = rad(to.lat)
  const dLng = rad(to.lng - from.lng)
  const y = Math.sin(dLng) * Math.cos(lat2)
  const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng)
  if (x === 0 && y === 0) return 0
  return ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360
}
